import gql from 'graphql-tag';
import { useQuery } from 'react-query';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { useOptimizelyFeature } from 'client/hooks/useOptimizelyFeature';
import webIdGenerator from 'anchor-server-common/utilities/webIdGenerator';
import { MumsAPI, MUMS_QUERY_KEY } from '.';

export const query = gql`
  query Viewer($showId: Float!) {
    viewer {
      permissionsForShow(showId: $showId)
      authorizedShows {
        active
        stationId
        title
        created
        showId
        webStationId
      }
    }
  }
`;

function useViewerPermissions() {
  const {
    state: { currentWebStationId },
  } = useCurrentUserCtx();

  const VIEW_PERMISSIONS_QUERY_KEY = 'viewerPermissions';
  const [MUMS_FEATURE_FLAG] = useOptimizelyFeature('mums');

  const { data } = useQuery(
    [MUMS_QUERY_KEY, currentWebStationId, VIEW_PERMISSIONS_QUERY_KEY],
    () => {
      return MumsAPI.Viewer({
        showId: webIdGenerator.getStationIdFromWebStationId(
          currentWebStationId!
        ),
      });
    },
    {
      enabled: MUMS_FEATURE_FLAG,
    }
  );

  return { data };
}

export { useViewerPermissions };
